import BaseComponent from "../base-component.js";
import {h, Fragment} from "preact"

export default class GriddedPreviewComponent extends BaseComponent {
  responseCollector() {
    return <>
        {this.props.item.correctResponse.definition?.map((def, idx, defList) => {
            let res = <p>{def.match}</p>
            if(defList[idx + 1]?.match) {
                res = <>
                    <p style="margin-bottom: 0px;">{def.match}</p>
                    <b>OR</b>
                </>
            }
            return res
        })}
    </>
  }

  render() {
    return(
      this.wrapper(
        this.body(), this.responseCollector()
      )
    );
  }
}